import React, { memo } from "react";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

// TODO: define function types
type actionTypes = {
  handleEdit?: any;
  handleDelete?: any;
  translation?: (id: string) => void;
};
type propsType = {
  tableHeaders: {}[];
  tableBody: {}[];
  actions?: actionTypes;
};
const Table = (props: propsType) => {
  console.log("table rendered");
  return (
    <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr className="h-12">
            <th className="px-3" scope="col">
              #
            </th>
            {props.tableHeaders.map((item: any, i: number) => {
              return (
                <th key={i} className="capitalize" scope="col">
                  {item.title.replaceAll("_", " ")}
                </th>
              );
            })}
            {props.actions && <th>Actions</th>}
          </tr>
        </thead>
        <tbody className="text-[16px]">
          {props.tableBody.map((data: any, index: number) => (
            <tr
              key={data.id}
              className="h-12 border-b border-b-gray-300  transition-all hover:shadow-md"
            >
              <td className="px-3">{index + 1}</td>
              {props.tableHeaders.map((header: any, i: number) => {
                if (header.img) {
                  return (
                    <td key={i}>
                      <img
                        src={`${process.env.REACT_APP_API}/uploads/images/${
                          data[header.title]
                        }`}
                        alt={data[header.title]}
                        className="h-24 w-24 object-cover"
                      />
                    </td>
                  );
                }
                if (header.html) {
                  return (
                    <td key={i}>
                      <div
                        dangerouslySetInnerHTML={{ __html: data[header.title] }}
                        className="line-clamp-1"
                      ></div>
                    </td>
                  );
                }
                return <td key={i}>{data[header.title]}</td>;
              })}

              <td className="">
                {/* props.actions.handleEdit */}
                <div className="flex items-center space-x-4">
                  {props.actions?.handleEdit && (
                    <div
                      className="cursor-pointer hover:text-primary"
                      onClick={() => {
                        props.actions?.handleEdit(data.id);
                      }}
                    >
                      <FaEdit />
                    </div>
                  )}

                  {props.actions?.handleDelete && (
                    <div
                      className="cursor-pointer hover:text-error"
                      onClick={() => props.actions?.handleDelete(data.id)}
                    >
                      <FaTrashAlt />
                    </div>
                  )}

                  {props.actions?.translation && (
                    <div
                      className="cursor-pointer hover:text-error bg-green-500 p-2 text-white rounded-md"
                      onClick={() =>
                        props.actions?.translation &&
                        props.actions?.translation(data.id)
                      }
                    >
                      Translate
                    </div>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(Table);
